(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection-product-grid"]) return;
  try {
    
  document.querySelectorAll('[data-tt-collection-organizer]').forEach((organizer) => {
    if (organizer.dataset.ttReady === 'true') return;
    organizer.dataset.ttReady = 'true';
    const section = organizer.closest('.section') || document;
    const grid = section.querySelector('#product-grid');
    if (grid && organizer.dataset.ttDefaultGrouping === 'true') {
      const items = Array.from(grid.querySelectorAll('[data-tt-product-item]'));
      items.sort((first, second) => Number(first.dataset.ttSortRank) - Number(second.dataset.ttSortRank));
      items.forEach((item) => grid.appendChild(item));
    }
    organizer.querySelectorAll('[data-tt-filter]').forEach((button) => {
      button.addEventListener('click', () => {
        const filter = button.dataset.ttFilter;
        section.querySelectorAll('[data-tt-product-item]').forEach((item) => {
          const groups = (item.dataset.ttGroups || '').split(/\s+/);
          item.hidden = filter !== 'all' && !groups.includes(filter);
        });
        organizer.querySelectorAll('[data-tt-filter]').forEach((option) => {
          const active = option === button;
          option.classList.toggle('is-active', active);
          option.setAttribute('aria-pressed', String(active));
        });
      });
    });
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tiny-tummy-journey"] && !Shopify.designMode) return;
  try {
    
  document.querySelectorAll('[data-tt-stage-finder]').forEach((finder) => {
    const form = finder.querySelector('[data-stage-form]');
    const input = form.querySelector('input[name="baby_age"]');
    const result = finder.querySelector('[data-stage-result]');
    const title = result.querySelector('[data-stage-title]');
    const copy = result.querySelector('[data-stage-copy]');

    form.addEventListener('submit', (event) => {
      event.preventDefault();
      const age = Number(input.value);

      if (!Number.isFinite(age) || age < 1) return;

      let stage = 'early';
      if (age >= 12) stage = 'confident';
      else if (age >= 9) stage = 'growing';
      else if (age >= 6) stage = 'first';

      title.textContent = finder.dataset[`${stage}Title`];
      copy.textContent = finder.dataset[`${stage}Copy`];
      result.hidden = false;
      result.scrollIntoView({ behavior: 'smooth', block: 'nearest' });
    });
  });

  } catch(e) { console.error(e); }
})();
})();
